import { KlantConversationalConnectorModule } from '@klant/conversational-connector/klant-conversational-connector.module';
import { KlantConversationalModule } from '@klant/conversational/klant-conversational.module';
import { ConversationalChatContainerModule } from '@klant/conversational/conversational-chat-container/conversational-chat-container.module';

import { NgModule } from '@angular/core';

import { ApPersistenceService } from '@ap/persistence';
import { ApErrorComponent } from '@ap/error';

import { MijnKlantConversationalComponent } from './mijn-klant-conversational.component';

/**
 * @ngdoc module
 * @name MijnKlantConversationalModule
 **/
@NgModule({
    declarations: [MijnKlantConversationalComponent],
    imports: [KlantConversationalConnectorModule, KlantConversationalModule, ConversationalChatContainerModule, ApErrorComponent],
    providers: [ApPersistenceService],
    exports: [MijnKlantConversationalComponent]
})
export class MijnKlantConversationalModule {}
